module.exports = __webpack_public_path__ + "static/media/ils_gold_purchase_failed.ba8d9f10.svg";